module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: _vm.componentId
  }, [_c('button', {
    staticClass: "button small",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Vehicles")]), _c('h2', [_vm._v("Segment SG" + _vm._s(_vm.segment.id) + " " + _vm._s(_vm.segment.name))]), _c('label', [_vm._v("Vehicles")]), _c('SelectizeVehicle', {
    ref: "select",
    attrs: {
      "maxItems": null
    },
    on: {
      "optionSelected": _vm.add
    }
  }), _c('ActionButton', {
    attrs: {
      "disabled": _vm.selected.delete.length || !_vm.selected.add.length,
      "action": _vm.saveVehicles
    }
  }, [_vm._v("Add")]), _c('base-list', {
    ref: "list",
    attrs: {
      "component": _vm.component,
      "componentType": "federationList",
      "dataLoader": _vm.dataLoader,
      "selectableList": true,
      "resultsPerPage": 5
    },
    model: {
      value: (_vm.selected.delete),
      callback: function($$v) {
        _vm.$set(_vm.selected, "delete", $$v)
      },
      expression: "selected.delete"
    }
  }), _c('template', {
    slot: "footer"
  }, [_c('ActionButton', {
    attrs: {
      "disabled": _vm.selected.delete.length === 0,
      "action": _vm.deleteVehicles
    }
  }, [_vm._v("Delete"), (_vm.selected.delete.length) ? _c('span', [_vm._v(" " + _vm._s(_vm.selected.delete.length))]) : _vm._e()])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b125308!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/SegmentSlotsReveal.vue
// module id = 2252
// module chunks = 1